import { appCopy } from '../../app-ui/baseline';
import { albumPath } from '../../components/content/albumPath';
import { discoveryReason, uniqueBy } from '../discovery/presentation';
import { planSponsoredInsertions } from '../ads/placement';

// SearchScreen has its own selection contract. Do not change Home/Explore through shared cards.
export function searchHomeContent(data = {}, home = {}, locale = 'ko', campaigns = []) {
  const t = (key, params) => appCopy(locale, key, params);
  const fallback = [];
  const add = (item, key, openReview = false) => {
    if (!item || fallback.some((card) => card.key === `review-${item.reviewId}`)) return;
    fallback.push({
      key: `review-${item.reviewId}`,
      albumId: item.albumId,
      title: item.albumTitle,
      subtitle: item.artist?.name || t('common.artist'),
      imageUrl: item.albumImageUrl,
      explicit: item.albumContentRating === 'EXPLICIT',
      eyebrow: t(key),
      to:
        albumPath(item) + (openReview ? `/user-reviews/${encodeURIComponent(item.reviewId)}` : ''),
    });
  };
  add(home.koreanMusicReviews?.[0], 'search.koreanMusic');
  add(home.globalMusicReviews?.[0], 'search.internationalMusic');
  add(home.recommendedReviews?.[1], 'search.postpopPick');
  add(home.featuredReviews?.[1], 'search.worthExploring');
  add(home.latestReviews?.[0], 'search.worthExploring', true);
  if (fallback.length < 4) add(home.latestReviews?.[1], 'search.worthExploring', true);
  const personal = (data.albums || []).map((item, index) => {
    const reasonKey = {
      RECENTLY_EXPLORED_ARTIST: 'search.reason.exploredArtist',
      RECENTLY_EXPLORED_MUSIC: 'search.reason.exploredMusic',
      RECENT_REVIEWS: 'search.worthExploring',
      GENERAL_DISCOVERY: 'search.worthExploring',
    }[item.reason];
    return {
      key: `discovery-album-${item.id}`,
      albumId: item.id,
      title: item.title,
      subtitle: item.artist?.name || t('common.artist'),
      imageUrl: item.imageUrl,
      // Submitted SearchScreen does not pass explicit on personalized cards.
      eyebrow: reasonKey ? t(reasonKey) : discoveryReason(item, t, locale),
      to: albumPath(item),
      tracking: { item, position: index + 1 },
    };
  });
  let albums = fallback.slice(0, 4);
  if (personal.length) {
    const candidates = uniqueBy([...personal, ...albums], 'albumId');
    const pick = candidates.find((card) => card.eyebrow === t('search.postpopPick'));
    const others = candidates.filter((card) => card.eyebrow !== t('search.postpopPick'));
    albums = (pick ? [...others.slice(0, 2), pick, ...others.slice(2)] : others).slice(0, 4);
  }
  const eligible = campaigns.filter(
    (campaign) => campaign.albums?.length && campaign.placements?.[0]?.format === 'NATIVE_ALBUM',
  );
  const advertised = new Set(
    eligible.flatMap((campaign) => campaign.albums.map((album) => album.id)),
  );
  albums = albums.filter((card) => !advertised.has(card.albumId));
  planSponsoredInsertions(eligible, albums.length).forEach(
    ({ at, campaign, occurrence }, offset) => {
      const album = campaign.albums[0];
      albums.splice(at + offset, 0, {
        key: `sponsored-taste-${campaign.id}-${occurrence}`,
        albumId: album.id,
        title: album.title,
        subtitle: album.artist?.name || t('common.artist'),
        imageUrl: album.imageUrl,
        explicit: album.contentRating === 'EXPLICIT',
        campaign,
        // Native SearchScreen always opens the campaign's first album, even when it has a CTA.
        to: album.slug
          ? albumPath(album)
          : albumPath({ albumSource: album.albumSource, sourceId: album.sourceId }),
      });
    },
  );
  const rows = (kind, fallbackItems, id, count) =>
    uniqueBy(
      [
        ...(data[kind] || []).map((entry, index) => ({
          ...entry[kind === 'reviews' ? 'review' : 'playlist'],
          tracking: {
            item: { ...entry[kind === 'reviews' ? 'review' : 'playlist'], reason: entry.reason },
            position: index + 1,
          },
        })),
        ...fallbackItems,
      ],
      id,
    ).slice(0, count);
  return {
    albums: albums.slice(0, 4),
    reviews: rows('reviews', home.latestReviews || [], 'reviewId', 2),
    playlists: rows('playlists', home.latestLists || [], 'id', 3),
  };
}
export function searchReviewExcerpt(item, locale) {
  return (
    item.content?.replace(/^[“"']+|[”"']+$/g, '').trim() ||
    (locale === 'en'
      ? item.recommendationCommentEn?.trim() || item.recommendationComment
      : item.recommendationComment) ||
    item.albumTitle
  );
}
